getDiffOptions